export default {
      id: "funds-reverse-usage",
      viewBox: "0 0 28 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#funds-reverse",
      toString: function () {
        return this.url;
      }
    }